import {useAlternateLocales} from '@aboutyou/config';
import {GetCountrySwitchResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/country_detection/v1/service.types';
import {COLORS} from '@aboutyou/ui-components';
import React, {ComponentProps} from 'react';
import {useIsHintCovered} from '../../features/ShopHint/hooks/useIsHintCovered';
import {useDeviceQueryParam} from '../../shared-deprecated/useDeviceQueryParam';
import {useLanguagesList} from './hooks/useLanguageList';
import {LanguageCountrySwitch} from './components/LanguageCountrySwitch';

type Props = GetCountrySwitchResponse & {
  className?: string;
  labelAndBorderColor?: COLORS;
  openAs: 'flyout' | 'popup';
  overlayWrapperZIndex?: number;
  shouldUseBorderOnHover?: boolean;
  shouldDisplayArrowOnHover?: boolean;
};

export const LanguageCountrySwitchView: React.FC<Props> = ({
  className,
  countrySwitch,
  labelAndBorderColor,
  openAs,
  overlayWrapperZIndex,
  shouldUseBorderOnHover,
  shouldDisplayArrowOnHover,
}) => {
  const alternateLanguages = useAlternateLocales();
  const isDeviceinQueryParams = useDeviceQueryParam();
  const {setIsHintCovered} = useIsHintCovered();

  const languagesList = useLanguagesList({
    languageSelection: countrySwitch.languageSelection,
    alternateLanguages,
  });

  if (isDeviceinQueryParams) {
    return null;
  }

  if (!countrySwitch) {
    return null;
  }

  const {countries, selectedShop} = countrySwitch;

  const selectedCountryFlagSrc = selectedShop?.flag?.url;
  const selectedCountryLabel = selectedShop?.countryLabel;
  const selectedLanguageLabel = selectedShop?.languageLabel;

  const countriesList = countries.map(country => ({
    flagSrc: country.flag?.url,
    isSelected: country.isCurrentCountry,
    label: country.countryName,
    linkTarget: country.link?.url,
  }));

  return (
    <LanguageCountrySwitch
      className={className}
      countries={countriesList}
      labelAndBorderColor={labelAndBorderColor}
      languages={
        languagesList as unknown as ComponentProps<
          typeof LanguageCountrySwitch
        >['languages']
      }
      openAs={openAs}
      onHover={setIsHintCovered}
      overlayWrapperZIndex={overlayWrapperZIndex}
      selectedCountryFlagSrc={selectedCountryFlagSrc}
      selectedCountryLabel={selectedCountryLabel}
      selectedLanguageLabel={selectedLanguageLabel}
      shouldUseBorderOnHover={shouldUseBorderOnHover}
      shouldDisplayArrowOnHover={shouldDisplayArrowOnHover}
    />
  );
};
